﻿import Vue from 'vue'

import VueVisible from 'vue-visible'
Vue.use(VueVisible)

import Storage from 'vue-ls'
Vue.use(Storage)

export { Vue }